import { render, staticRenderFns } from "./Applicant.vue?vue&type=template&id=5b189e2c&"
import script from "./Applicant.vue?vue&type=script&lang=ts&"
export * from "./Applicant.vue?vue&type=script&lang=ts&"
import style0 from "./Applicant.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports